<template>
  <div>
    <TableFilters
      :filters="['supplier', 'warehouse', 'dateRange']"
      v-model="filter"
      :columns="columns"
      @updateColumnsTable="updateColumnsTable"
      :export="[`purchaseorderexport`]"
    ></TableFilters>
    <v-row class="py-0 my-0">
      <v-col cols="12" md="12" lg="7" class="pa-5">
        <v-btn-toggle v-model="toggle_exclusive">
          <v-btn @click="viewpdfFile()"> View Report </v-btn>
          <v-btn @click="pdfdownload()"> Generate PDF </v-btn>
          <v-btn @click="exceldownload()"> Generate CSV </v-btn>
        </v-btn-toggle>
      </v-col>
    </v-row>
    <v-card class="lighten-12 mt-2" v-show="false">
      <v-container fluid class="light gray lighten-12">
        <v-row>
          <v-card-text class="pa-0">
            <v-data-table
              :items-per-page="1000"
              :fixed-header="true"
              :headers="headers"
              :items="PurchaseOrderList"
              class="row-pointer"
              item-key="id"
              id="indextable3"
            >
              <template v-slot:no-data>
                <div class="mt-16 container justify-center item-center">
                  <noData name="Order" />
                </div>
              </template>
              <template v-slot:item.reference_number="{ item }">
                <CopyTableCell :text="item.reference_number"></CopyTableCell>
              </template>
              <template
                v-slot:item.date="{ item }"
                v-slot="{ errors }"
                name="value"
                rules="numeric"
                >{{ item.date | formatDate }}</template
              >
              <template
                v-slot:item.supplier="{ item }"
                v-slot="{ errors }"
                name="Quantity"
                rules="numeric"
                >{{ item.supplier | hasName }}</template
              >
              <template
                v-slot:item.supplier="{ item }"
                v-slot="{ errors }"
                name="Quantity"
                rules="numeric"
                >{{ item.supplier.name }}</template
              >

              <template
                v-slot:item.status="{ item }"
                v-slot="{ errors }"
                name="Quantity"
                rules="numeric"
              >
                <v-chip
                  :x-small="true"
                  class="ma-2"
                  label
                  text-color="white"
                  :color="getPurchaseOrderStatusColor(item.status)"
                  dark
                  >{{ item.status }}</v-chip
                >
              </template>
              <template v-slot:item.wareHouse="{ item }" v-slot="{ errors }">
                {{
                  WarehouseView == 'name'
                    ? item.wareHouse.name
                    : item.wareHouse.sortform
                }}</template
              >
              <!-- Status -->
            </v-data-table>
          </v-card-text>
        </v-row>
      </v-container>
    </v-card>
  </div>
</template>
<script>
import TableFilters from '@/components/base/TableFilters';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import XLSX from 'xlsx';
import { DateTime } from '@grapecity/wijmo';
import moment from 'moment';
import _ from 'lodash';
import noData from '@/components/shared/noItem';
import { mapState } from 'vuex';

export default {
  // mixins: [Suppliers],
  data: () => ({
    hide: '',
    purchaseOrderStatus: ['Pending', 'Canceled', 'Received'],
    messages: [],
    errors: [],
    status: [
      { text: 'Active', value: 'active' },
      { text: 'Archived', value: 'archived' },
    ],
    columns: [
      {
        text: 'No',
        value: 'no',
        show: true,
        disabled: false,
        width: '14%',
        render: (item) => item?.no,
      },
      {
        text: 'Date',
        value: 'date',
        show: true,
        disabled: false,
        width: '12.5%',
        render: (item) => moment(item.date).format('YYYY-MM-DD'),
      },
      {
        text: 'Reference no',
        value: 'reference_number',
        show: true,
        disabled: false,
        width: '12.5%',
        render: (item) => item?.reference_number,
      },
      {
        text: 'Supplier',
        value: 'supplier',
        show: true,
        disabled: false,
        width: '12.5%',
        render: (item) => item?.supplier.name,
      },
      {
        text: 'Warehouse',
        value: 'wareHouse',
        show: true,
        disabled: false,
        width: '12.5%',
        render: (item) => item?.wareHouse.name,
      },
      {
        text: 'Purchase order status',
        value: 'status',
        show: true,
        disabled: false,
        width: '12.5%',
        render: (item) => item?.status,
      },
    ],
    // For Purchase Order Table Data
    PurchaseOrderList: [],

    //For Filter
    date_range: [],
    filter: {
      invoice_status: '',
      start: '',
      end: '',
      amount: '',
      supplier: '',
      search: '',
      status: '',
    },
    menu: false,
  }),
  components: {
    TableFilters,
    noData,
  },
  created() {
    this.$store.commit('UPDATE_PDF_VISIBLE', false);
    this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', false);
  },

  watch: {
    filter(value) {
      this.$store.commit('UPDATE_PDF_DATAS', null);
      this.$store.commit('UPDATE_PDF_VISIBLE', false);
    },
  },
  computed: {
    ...mapState(['filterDatas']),
    ...mapState(['WarehouseView']),

    dateRangeText() {
      this.filter.start = this.date_range[0];
      this.filter.end = this.date_range[1];
      return this.date_range.join(' ~ ');
    },
    headers: function () {
      return this.columns.filter((item) => item.show == true);
    },
  },
  methods: {
    updateColumnsTable() {
      this.$store.commit('UPDATE_PDF_VISIBLE', false);
      this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', true);
      setTimeout(() => {
        this.$store.commit('UPDATE_PDF_HEADERS', this.headers);
        this.$store.commit('UPDATE_PDF_VISIBLE', true);
        this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', false);
      }, 100);
    },
    dateFormat: function (date) {
      return moment(date, 'YYYY-MM-DD').format('DD/MM/YYYY');
    },
    generateReport(callBack = () => {}) {
      this.$store.commit('UPDATE_PDF_VISIBLE', true);
      this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', true);
      var filter = this.filter;
      this.$store
        .dispatch('report/getPurchaseOrderReports', filter)
        .then((res) => {
          let i = 1;
          this.PurchaseOrderList = res.data.data;
          this.PurchaseOrderList.map((p) => {
            p.no = i;
            i++;
          });

          setTimeout(() => {
            // Update Pdf To List
            callBack();
            this.$store.commit('UPDATE_PDF_HEADERS', this.headers);
            // Update Pdf To List Datas
            this.$store.commit('UPDATE_PDF_DATAS', this.PurchaseOrderList);
            // Update Pdf To List_Title
            this.$store.commit('UPDATE_PDF_TITLE', 'Purchase Order Report');
            this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', false);
          }, 100);
        })
        .catch((err) => {
          this.isLoading = false;
          this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', false);
          this.$store.commit('UPDATE_PDF_VISIBLE', false);
          this.messages = err.data.title;
        });
    },
    async viewpdfFile() {
      await this.generateReport();
      setTimeout(() => {
        if (this.PurchaseOrderList.length > 0) {
          this.$store.commit('UPDATE_PDF_VISIBLE', true);
          this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', false);
        }
      }, 400);
    },
    //Product Details Export Pdf
    async pdfdownload() {
      const printPdf = () => {
        let Data = _.cloneDeep(this.PurchaseOrderList);
        for (let x = 0; x < Data.length; x++) {
          Data[x].date = moment(Data[x].date, 'YYYY-MM-DD').format(
            'DD/MM/YYYY',
          );
          Data[x].supplier = Data[x].supplier.name;
          Data[x].wareHouse = Data[x].wareHouse.name;
        }
        var rows = Data;
        var doc = jsPDF({
          orientation: 'landscape',
        });
        doc.setFontSize(13);
        // doc.setFontType("bold");
        doc.setTextColor(26, 26, 26);
        doc.setFont('helvetica', 'normal');
        doc.text('Purchase Order Report', 15, 6);

        doc.setFontSize(8);
        doc.text(
          250,
          6,
          `Generated Date and Time  -  ${moment(today).format(
            'DD-MM-YYYY HH:MM:SS',
          )}`,
          'center',
        );

        //let height;
        //if (
        // (this.filterDatas.start == "" || this.filterDatas.start == null) &&
        // (this.filterDatas.end == "" || this.filterDatas.end == null) &&
        // (this.filterDatas.supplierquery == "" ||
        //   this.filterDatas.supplierquery == null) &&
        // (this.filterDatas.warehousequery == "" ||
        // this.filterDatas.warehousequery == null)
        // ) {
        // height = 11;
        // } else if (
        //  (this.filterDatas.supplierquery == "" ||
        //  this.filterDatas.supplierquery == null) &&
        //(this.filterDatas.warehousequery == "" ||
        //this.filterDatas.warehousequery == null)
        //) {
        //this.filterDatas.start && this.filterDatas.end
        //? doc.text(
        //  `Date Range              -     ${this.filterDatas.start}  -  ${this.filterDatas.end}`,
        //15,
        //12
        //)
        //: null;
        //height = 15;
        //} else if (
        // (this.filterDatas.start == "" || this.filterDatas.start == null) &&
        //(this.filterDatas.end == "" || this.filterDatas.end == null) &&
        //(this.filterDatas.warehousequery == "" ||
        // this.filterDatas.warehousequery == null)
        //) {
        //this.filterDatas.supplierquery
        //? doc.text(
        //  `Supplier               -     ${this.filterDatas.supplierquery}`,
        //15,
        //12
        //)
        // : null;
        //height = 15;
        //} else if (
        // (this.filterDatas.start == "" || this.filterDatas.start == null) &&
        //(this.filterDatas.end == "" || this.filterDatas.end == null) &&
        //(this.filterDatas.supplierquery == "" ||
        // this.filterDatas.supplierquery == null)
        //) {
        //this.filterDatas.warehousequery
        //? doc.text(
        //   `Warehouse               -     ${this.filterDatas.warehousequery}`,
        // 15,
        //12
        //)
        //: null;
        //height = 15;
        //} else if (
        //this.filterDatas.warehousequery == "" ||
        //this.filterDatas.warehousequery == null
        //) {
        //this.filterDatas.start && this.filterDatas.end
        //? doc.text(
        //  `Date Range         -     ${this.filterDatas.start}  -  ${this.filterDatas.end}`,
        //15,
        //12
        //)
        //: null;
        //this.filterDatas.supplierquery
        //? doc.text(
        //  `Supplier               -     ${this.filterDatas.supplierquery}`,
        //15,
        //17
        //)
        //: null;
        //height = 20;
        //} else if (
        //this.filterDatas.supplierquery == "" ||
        //this.filterDatas.supplierquery == null
        //) {
        //this.filterDatas.start && this.filterDatas.end
        //? doc.text(
        //  `Date Range         -     ${this.filterDatas.start}  -  ${this.filterDatas.end}`,
        //15,
        //12
        // )
        //: null;
        //this.filterDatas.warehousequery
        // ? doc.text(
        //   `Warehouse          -     ${this.filterDatas.warehousequery}`,
        // 15,
        //17
        //)
        //: null;
        //height = 20;
        //} else if (
        // (this.filterDatas.start == "" || this.filterDatas.start == null) &&
        //(this.filterDatas.end == "" || this.filterDatas.end == null)
        //) {
        //this.filterDatas.start && this.filterDatas.end;
        //this.filterDatas.supplierquery
        //? doc.text(
        //  `Supplier               -     ${this.filterDatas.supplierquery}`,
        //15,
        //12
        //)
        //: null;
        //this.filterDatas.warehousequery
        //? doc.text(
        //  `Warehouse          -     ${this.filterDatas.warehousequery}`,
        //15,
        //17
        //)
        //: null;
        //height = 20;
        //} else {
        // height = 25;
        //this.filterDatas.start && this.filterDatas.end
        // ? doc.text(
        //  `Date Range            -     ${this.filterDatas.start}  -  ${this.filterDatas.end}`,
        //  15,
        //  12
        //)
        //: null;
        //this.filterDatas.supplierquery
        // ? doc.text(
        //    `Supplier                  -     ${this.filterDatas.supplierquery}`,
        //    15,
        //    17
        //  )
        //: null;
        //this.filterDatas.warehousequery
        //  ? doc.text(
        //     `Warehouse             -     ${this.filterDatas.warehousequery}`,
        //    15,
        //    22
        //  )
        //: null;
        //}

        const conditions = [
          { key: 'supplierquery', label: 'Supplier' },
          { key: 'warehousequery', label: 'Warehouse' },
        ];

        // Function to get text based on filter data
        const getText = (key, label, value) => {
          return value ? `${label} - ${value}` : '';
        };

        // Iterate over conditions and build the text
        let height = conditions.reduce((acc, condition) => {
          const value = this.filterDatas[condition.key];
          const text = getText(
            condition.key,
            condition.label,
            value,
            condition.offset,
          );

          if (text) {
            doc.text(text, 15, acc);
            return acc + 5;
          }

          return acc;
        }, 12); // Initial offset

        // Add Date Range if both start and end are available
        if (this.filterDatas.start && this.filterDatas.end) {
          const dateRangeText = `Date Range - ${this.filterDatas.start} - ${this.filterDatas.end}`;
          doc.text(dateRangeText, 15, height);
          height += 5; // Increment offset
        }

        // Set a default height if no conditions matched
        height = height || 20;

        doc.autoTable(
          this.headers.map((h) => {
            return { title: h.text, dataKey: h.value };
          }),
          rows,
          {
            didParseCell: function (data) {
              if (data.column.dataKey === 'addsress') {
                data.cell.text = data.cell.raw.country;
              }
            },
            startY: height,
          },
        );
        const today = new DateTime();
        doc.save(`${moment(today).format('DD-MM-YYYY')}-PurchaseOrder.pdf`);
      };
      this.generateReport(printPdf);
    },

    //Product Details Export Excel
    async exceldownload() {
      const printExcel = () => {
        var data = document.getElementById('indextable3');
        const today = new DateTime();
        const headData = XLSX.utils.table_to_sheet(data);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(
          wb,
          headData,
          moment(today).format('DD-MM-YYYY'),
        );
        XLSX.writeFile(
          wb,
          `${moment(today).format('DD-MM-YYYY')}-PurchaseOrder.xlsx`,
        );
      };
      this.generateReport(printExcel);
    },
    getPurchaseOrderStatusColor(status) {
      switch (status) {
        case 'Received':
          return 'green';
          break;
        case 'Pending':
          return 'orange';
          break;
        case 'Canceled':
          return 'red';
          break;
        default:
          break;
      }
    },
  },
};
</script>
